import { createDiscreteApi } from "naive-ui";
import HttpResponse from "./VO/HttpResponse";
import Global from "./Global";

export default class Tools {
    /**
    * 获取网络文件
    * @param url 请求地址
    * @param method 模式
    * @param body 数据
    * @param [checkTimeOut=false] 是否检查超时
    */
    public static async FetchGetFileAsync(url: string, body: any, method: "POST" | "GET" | "DELETE" | "PUT" | "PATCH",
        ContentType: 'application/json' | 'text/plain' | 'multipart/form-data' | 'application/x-www-form-urlencoded' = 'application/json',
        Headers: { [key: string]: any }
    ): Promise<Blob> {
        switch (method) {
            case "GET":
            case "DELETE":
                break;
            default:
                break;
        }

        let fetchBody: BodyInit | undefined
        switch (method) {
            case "GET":
            case "DELETE":
                delete Headers['Content-Type'];
                if (body != null && Object.keys(body).length > 0)
                    url += '?';
                for (const key in body) {
                    url += `${key}=${encodeURIComponent(body[key])}&`;
                }
                if (url.endsWith('&'))
                    url = url.substring(0, url.length - 1);
                break;
            default:
                switch (ContentType) {
                    case "application/json":
                        fetchBody = JSON.stringify(body);
                        break;
                    case "application/x-www-form-urlencoded":
                        const urlSearchParams = new URLSearchParams();
                        Object.keys(body).forEach(key => {
                            urlSearchParams.append(key, String(body[key]));
                        });
                        fetchBody = urlSearchParams.toString();
                        break;
                    case "multipart/form-data":
                        delete Headers['Content-Type'];
                        const formData = new FormData();
                        Object.keys(body).forEach(key => {
                            formData.append(key, body[key]);
                        });
                        fetchBody = formData;
                        break;
                    case "text/plain":
                        fetchBody = typeof body === "string" ? body : JSON.stringify(body);
                        break;
                }
                break;
        }
        return new Promise(r => {
            globalThis.fetch(url, {
                headers: Headers,
                method: method,
                body: fetchBody
            }).then(resp => {

                //#region 经过类型处理

                //#endregion

                return resp.blob();
            }).then(v => {
                r(v);
            });
        });
    }


    /**
     * Get请求
     * @param action 
     * @param getContent 
     * @returns 
     */
    public static FetchGetAsync<T = any>(action: string, getContent: any) {
        return this.FetchAsync<T>(action, getContent, "GET", "text/plain");
    }

    
    /**
     * 进行网络请求
     * @param action 具体指令
     * @param method 模式
     * @param body 数据
     * @param [checkTimeOut=false] 是否检查超时
     */
    public static async FetchAsync<T = any>(action: string, body: any, method: "POST" | "GET" | "DELETE" | "PUT" | "PATCH",
        ContentType: 'application/json' | 'text/plain' | 'multipart/form-data' | 'application/x-www-form-urlencoded' = 'application/json'
    ): Promise<HttpResponse<T>> {
        let url = Global.GetAPIUrl(action);


        const headers: HeadersInit = {
            "Content-Type": ContentType
        };
        const authToken = localStorage.getItem('auth_token');
        if (authToken) {
            (headers as any)['X-Auth-Token'] = authToken;
        }
        switch (method) {
            case "GET":
            case "DELETE":
                break;
            default:
                break;
        }

        for (const key in body) {
            if (Object.prototype.hasOwnProperty.call(body, key)) {
                const v = body[key];
                if (v == null || v == undefined) {
                    delete body[key];
                }
            }
        }


        let fetchBody: BodyInit | undefined
        switch (method) {
            case "GET":
            case "DELETE":
                delete headers['Content-Type'];
                if (body != null && Object.keys(body).length > 0)
                    url += '?';
                for (const key in body) {
                    url += `${key}=${encodeURIComponent(body[key])}&`;
                }
                if (url.endsWith('&'))
                    url = url.substring(0, url.length - 1);
                break;
            default:
                switch (ContentType) {
                    case "application/json":
                        fetchBody = JSON.stringify(body);
                        break;
                    case "application/x-www-form-urlencoded":
                        const urlSearchParams = new URLSearchParams();
                        Object.keys(body).forEach(key => {
                            urlSearchParams.append(key, String(body[key]));
                        });
                        fetchBody = urlSearchParams.toString();
                        break;
                    case "multipart/form-data":
                        delete headers['Content-Type'];
                        const formData = new FormData();
                        Object.keys(body).forEach(key => {
                            const v = body[key];
                            if (typeof v == "object") {
                                if ('length' in v) {
                                    for (let i = 0; i < v.length; i++) {
                                        formData.append(key, v[i]);
                                    }
                                }
                                else {
                                    formData.append(key, v);
                                }
                            }
                            else {
                                formData.append(key, v);
                            }
                        });
                        fetchBody = formData;
                        break;
                    case "text/plain":
                        fetchBody = typeof body === "string" ? body : JSON.stringify(body);
                        break;
                }
                break;
        }
        return new Promise(r => {
            globalThis.fetch(url, {
                headers: headers,
                method: method,
                body: fetchBody
            }).then(response => {

                //#region 进行类型处理
                const contentType = response.headers.get("Content-Type");
                if (contentType) {
                    if (contentType.includes('application/json')) {
                        // 处理 JSON 数据
                        return response.json();
                    } else if (contentType.includes('text/')) {
                        // 处理文本数据
                        return response.text();
                    } else if (contentType.includes('image/')) {
                        // 处理图片数据
                        return response.blob();
                    } else if (contentType.includes('audio/') || contentType.includes('video/')) {
                        // 处理音频或视频数据
                        return response.blob();;
                    } else {
                        // 处理其他类型的数据，默认作为 Blob 处理
                        return response.blob();
                    }
                }
                else {
                    // 没有 Content-Type 的情况
                    const blobData = response.blob();
                    return { type: 'unknown', data: blobData };
                }
                //#endregion
            }).then(v => {

                if (v instanceof Blob) {
                    const nResp = new HttpResponse<T>();
                    nResp.Code = 200;
                    nResp.Success = true;
                    nResp.Message = "";
                    nResp.Data = v as any as T;
                    r(nResp);
                    return;
                }
                else if (typeof v == "string") {
                    v = JSON.parse(v);
                }
                Object.setPrototypeOf(v, HttpResponse.prototype);
                r(v);
            });
        });
    }


    /**
     * 金额格式化：最多4位小数，去掉尾部多余的0
     * @param val 金额
     * @param options.showSign 是否显示 +/- 号
     * @param options.compact >=10000缩写为w，>=1亿缩写为y
     */
    static formatMoney(val: number | null | undefined, options?: { showSign?: boolean; compact?: boolean }): string {
        if (val == null) return '0';
        const { showSign = false, compact = false } = options || {};
        const abs = Math.abs(val);
        let displayVal = val;
        let suffix = '';

        if (compact) {
            if (abs >= 100000000) {
                displayVal = val / 100000000;
                suffix = 'y';
            } else if (abs >= 10000) {
                displayVal = val / 10000;
                suffix = 'w';
            }
        }

        // 最多4位小数
        let fixed = Math.abs(displayVal).toFixed(4);
        // 去掉尾部多余的0
        let trimmed = fixed.replace(/\.?0+$/, '');

        let sign = '';
        if (showSign) {
            sign = displayVal > 0 ? '+' : displayVal < 0 ? '-' : '';
        } else {
            sign = displayVal < 0 ? '-' : '';
        }

        return sign + trimmed + suffix;
    }

    /**
     * 弹出失败消息
     * @param ERROR_MESSAGE 
     */
    static AlertError(ERROR_MESSAGE: string | undefined) {
        const api = createDiscreteApi(['message']);
        api.message.error(ERROR_MESSAGE!);
    }

    /**
     * 弹出成功消息
     * @param SUCCESS_MESSAGE 
     */
    static AlertSuccess(SUCCESS_MESSAGE: string): void {
        const api = createDiscreteApi(['message']);
        api.message.success(SUCCESS_MESSAGE!);
    }
}